/* import __COLOCATED_TEMPLATE__ from './course-logo.hbs'; */
import Component from '@glimmer/component';
import type CourseModel from 'codecrafters-frontend/models/course';

interface Signature {
  Element: HTMLImageElement;

  Args: {
    course: CourseModel;
  };
}

export default class CourseLogo extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CourseLogo: typeof CourseLogo;
  }
}
